import { format, parse, parseISO } from 'date-fns';

export function cover24Hours(start: Date, end: Date) {
  return (
    format(start, 'hh:mm aa') === '12:00 AM' &&
    format(end, 'hh:mm aa') === '11:59 PM'
  );
}

export function parseTimeOnly(d: string): Date {
  let t = parse(d, 'HH:mm:ss.SSS', new Date());
  if (isNaN(t.getTime())) {
    t = parse(d, 'HH:mm:ss', new Date());
  }
  return t;
}

export function prettyTimeOnly(d: string) {
  return format(parseTimeOnly(d), 'hh:mm aa');
}

export function parseDateOnlyString(date: string): Date {
  // "2021-11-29T00:00:00Z"
  // Take string, remove Z and format the remaining 2021-11-29T00:00:00 with the included time.
  // By passing the time without a Z, parseISO creates the date object at 00:00:00 in Local Time which
  // allows us to use date-fns format without going backwards to the day before.
  const localizeDate = date.replace('Z', '');
  return parseISO(localizeDate);
}

/**
 * @deprecated use prettifyDateOnlyStringTemplate
 * @param apiDate
 * @param showYear
 */
export function prettifyDateOnlyString(apiDate: string, showYear = false) {
  const parsed = parseDateOnlyString(apiDate);
  return format(parsed, showYear ? 'MMM d, yyyy' : 'LLL d');
}

export function prettifyDateOnlyStringTemplate(
  apiDate: string,
  template: string
) {
  const parsed = parseDateOnlyString(apiDate);
  return format(parsed, template);
}
